'use client';

import { useState, useEffect } from 'react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { useRouter } from 'next/navigation';

const mapContainerStyle = {
  width: '100%',
  height: '70vh',
  minHeight: '400px',
};
const libraries = ['places']; // ✅ Required for geocoding
const defaultCenter = {
  lat: -33.8688, // Default: Sydney, Australia
  lng: 151.2093,
};

export default function ExploreMap({
  location,
  types,
  departureDate,
  returnDate,
}) {
  const [boats, setBoats] = useState([]);
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const burl = `${process.env.NEXT_PUBLIC_API}`;
  const router = useRouter();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY,
    libraries, // ✅ Added this
  });

  async function geocodeAddress(address) {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY}`,
      );
      const data = await response.json();
      if (data.status === 'OK') {
        return data.results[0].geometry.location;
      } else {
        console.error('Geocode error:', data.status);
        return null;
      }
    } catch (error) {
      console.error('Error fetching geolocation:', error);
      return null;
    }
  }

  function getUserLocation() {
    return new Promise((resolve) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          (error) => {
            console.error('Error getting user location:', error);
            resolve(null);
          },
        );
      } else {
        console.warn('Geolocation is not supported by this browser.');
        resolve(null);
      }
    });
  }

  useEffect(() => {
    async function fetchLocation() {
      let coordinates = null;
      if (location) {
        coordinates = await geocodeAddress(location);
      } else {
        coordinates = await getUserLocation();
      }

      if (coordinates) {
        setMapCenter(coordinates);
      }
    }
    fetchLocation();
  }, [location]);

  useEffect(() => {
    async function fetchBoats() {
      try {
        const userId = sessionStorage.getItem('userId');

        const requestBody = {
          userid: userId,
          startdate: departureDate,
          enddate: returnDate,
          userlat: mapCenter.lat,
          userlong: mapCenter.lng,
          types,
        };

        const response = await fetch(`${burl}/getlistallrentals.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch boats data');
        }

        const data = await response.json();
        setBoats(data.records || []);
      } catch (error) {
        console.error('Error fetching boats data:', error);
      }
    }

    if (mapCenter.lat && mapCenter.lng) {
      fetchBoats();
    }
  }, [mapCenter, burl, departureDate, returnDate]);

  return (
    <div className="w-full flex justify-center">
      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={mapCenter}
          zoom={13}
        >
          {boats.map((boat, index) =>
            boat.ulat && boat.ulong ? (
              <Marker
                key={`marker-${index}`}
                position={{
                  lat: parseFloat(boat.ulat),
                  lng: parseFloat(boat.ulong),
                }}
                title={boat.title}
                onClick={() => router.push(`/listing/${boat.id}`)}
              />
            ) : null,
          )}
        </GoogleMap>
      ) : (
        <p>Loading map...</p>
      )}
    </div>
  );
}
